import About from './about'
import Bible from './bible'
import BookShelf from './bookshelf'
import Latest from './bookshelf/latest.vue'
import Category from './category'
import CategoryAll from './category/all.vue'
import CategoryPriest from './category/priest.vue'
import Favourite from './favourite'
import Home from './home'
import lives from './lives/index.vue'
import livesRoom from './lives/Room.vue'
import More from './more'
import Movie from './movie'
import News from './news'
import NewsDetail from './news/Detail.vue'
import Note from './note'
import NoteEditor from './note/editor.vue'
import Pay from './pay'
import Phone from './phone/index.vue'
import Playback from './playback'
import Prayer from './prayer'
import Search from './search'
import Subscribe from './subscribe/root.vue'
import Suggest from './suggest'

export const root = [{
  name: 'home',
  path: '/',
  component: Home
}, {
  name: 'category',
  path: '/category',
  component: Category,
  meta: {
    title: '分类'
  }
},
{
  name: 'lives',
  path: '/lives',
  component: lives,
  meta: {
    title: '一起看'
  }
},
{
  name: 'live-room',
  path: '/lives/:id',
  component: livesRoom,
  meta: {
    title: ''
  }
},
{
  name: 'more',
  path: '/more',
  component: More,
  meta: {
    title: '更多'
  }
}]

export default [
  ...root, {
    name: 'bookshelf',
    path: '/bookshelf/:catid?',
    component: BookShelf
  }, {
    name: 'latest',
    path: '/latest',
    component: Latest
  }, {
    name: 'movie',
    path: '/movie/:movid',
    component: Movie,
    meta: {
      keepAlive: true
    }
  }, {
    name: 'category-all',
    path: '/category/all',
    component: CategoryAll,
    meta: {
      title: '全部分类'
    }
  }, {
    name: 'category-priest',
    path: '/category/priest',
    component: CategoryPriest,
    meta: {
      title: '牧者专栏'
    }
  }, {
    name: 'search',
    path: '/search',
    component: Search,
    meta: {
      title: '搜索'
    }
  }, {
    name: 'news',
    path: '/news',
    component: News,
    meta: {
      title: '站内公告'
    }
  }, {
    name: 'news-detail',
    path: '/news/:id',
    component: NewsDetail
  }, {
    name: 'suggest',
    path: '/suggest',
    component: Suggest,
    meta: {
      title: '留言反馈'
    }
  }, {
    name: 'prayer',
    path: '/prayer',
    component: Prayer,
    meta: {
      title: '代祷支持'
    }
  }, {
    name: 'about',
    path: '/about',
    component: About,
    meta: {
      title: '关于我们'
    }
  }, {
    name: 'favourite',
    path: '/favourite',
    component: Favourite,
    meta: {
      title: '我的收藏'
    }
  }, {
    name: 'playback',
    path: '/playback',
    component: Playback,
    meta: {
      title: '播放记录'
    }
  }, {
    name: 'note',
    path: '/note',
    component: Note,
    meta: {
      title: '我的笔记'
    }
  }, {
    name: 'note-editor',
    path: '/note/:movid/:urlid',
    component: NoteEditor,
    meta: {
      title: '编辑笔记'
    }
  }, {
    name: 'pay',
    path: '/pay',
    component: Pay,
    mate: {
      title: '奉献支持'
    }
  }, {
    name: 'bible',
    path: '/bible',
    component: Bible,
    mate: {
      title: '视频查经'
    }
  }, {
    name: 'subscribe',
    path: '/subscribe',
    component: Subscribe,
    meta: {
      title: '关注公众号'
    }
  }, {
    name: 'phone',
    path: '/phone',
    component: Phone,
    meta: {
      title: '绑定手机号'
    }
  },
]



// WEBPACK FOOTER //
// ./src/view/index.js